import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-action-buttons-renderer',
  template: `<ng-container *ngIf="showButtons">
    <button (click)="approve()" class="btn btn-success btn-sm" style="height: 22px !important; padding: 0px 7px 6px  !important; font-size: 14px  !important; margin-left: 13px  !important;">Approve</button>
    <button (click)="reject()" class="btn btn-danger btn-sm" style="height: 22px !important; padding: 0px 7px 6px  !important; font-size: 14px  !important; margin-left: 8px  !important;     color: #fff !important; background: #e97070 !important;">Reject</button>
    </ng-container>
  `
})
export class ActionButtonsRendererComponent implements ICellRendererAngularComp {
  params: any;
  showButtons = true;

  agInit(params: any): void {
    this.params = params;
    this.updateVisibility();
  }

  refresh(params: any): boolean {
    this.params = params;
    this.updateVisibility();
    return true; // forces the template to re-render
  }

  updateVisibility() {
    const flag = this.params.data.CheckFlag;
    this.showButtons = !flag || flag.trim() === '';
  }

  approve() {
    this.params.onApprove(this.params.data);
  }

  reject() {
    this.params.onReject(this.params.data);
  }
}